// Library
import React from 'react';

// CSS & Images
import '../../css/App.css';
import wideshot from '../../images/feardragon-wide-shot.jpg';
import twitterIcon from '../../images/twitter-icon.png';
import twitchIcon from '../../images/twitch-icon.png';
import youtubeIcon from '../../images/youtube-icon.png';

// Components
import Header from '../Header';

function IndexPage() {
  return (
    <div className="App">
      <Header />
      <div className="home-top-content">
        <div className="home-feardragon-logo-container" >
          <img className="home-feardragon-logo" src={wideshot}/>
          <div className="home-feardragon-text">
            Photo credit <u><a href="http://www.twitter.com/borodasltv">@borodasltv</a></u>.
          </div>
        </div>
        <div className="home-description">
          <p>Hi! My name is Ravi "feardragon" Pareek. I am an esports
            commentator and content creator that specializes in StarCraft 2.</p>
          <p>I am also a software developer so this website is a merging
            between my work and any public esports apps I've made.</p>
          <p>If you'd like to have me at your event, send me an email
            at <a href="mailto:caster@feardragon.com">caster@feardragon.com</a>
          .</p>
        </div>
      </div>
      <div className="home-social-media-bar">
        <a href="https://www.twitter.com/feardragon64">
          <img className="home-social-media-icon" src={twitterIcon}/>
        </a>
        <a href="https://www.twitch.tv/feardragon64">
          <img className="home-social-media-icon" src={twitchIcon}/>
        </a>
        <a href="https://www.youtube.com/feardragon64">
          <img className="home-social-media-icon" src={youtubeIcon}/>
        </a>
      </div>
      <div className="home-highlight-reel">
        <iframe width="70%" height="100%"
          src="https://www.youtube.com/embed/IW2Uq7e2AXY">
        </iframe>
      </div>
    </div>
  );
}

export default IndexPage;
